import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {HttpClientModule, HttpClient} from '@angular/common/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {MultiTranslateHttpLoader} from "ngx-translate-multi-http-loader";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
      {prefix: "./assets/translate/landing/", suffix: ".json"},
      {prefix: "./assets/translate/menu/", suffix: ".json"},
      {prefix: "./assets/translate/product/", suffix: ".json"},
      {prefix: "./assets/translate/checkout/", suffix: ".json"},
      {prefix: "./assets/translate/checkout/payment-mode/", suffix: ".json"},
      {prefix: "./assets/translate/checkout/confirmation-model/", suffix: ".json"},
      {prefix: "./assets/translate/thanks/", suffix: ".json"},
      {prefix: "./assets/translate/thanks/countdown/", suffix: ".json"},
      {prefix: "./assets/translate/thanks/sendReciept/", suffix: ".json"},
      {prefix: "./assets/translate/includes/userInactivity/", suffix: ".json"},
      {prefix: "./assets/translate/includes/back-prompt/", suffix: ".json"},
  ]);
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    })
  ],
  exports :[
    HttpClientModule,
    TranslateModule
  ]
})
export class LangTranslateModule { }